import SessionGame from './session';

export default SessionGame;
